import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import { AgilityImage } from "@agility/gatsby-image-agilitycms"
import { useState } from "react"
import { FiChevronUp, FiChevronDown } from "react-icons/fi"

const PublicationsListing = ({ module }) => {

    const data = useStaticQuery(graphql`
    query {
      publications: allAgilityPublications(sort: {fields: properties___itemOrder, order: ASC}) {
        nodes {          
          customFields {
            image {
              label
              url
              filesize
              pixelHeight
              pixelWidth
              height
              width
            }
            briefDescription
            publicationTypeID
            publicationTitle
            primaryButton {
              href
              target
              text
            }
            descriptionTruncated
          }      
        }
      }
    }
  `)

    // function to check whether or not the url is absolute
    const isUrlAbsolute = url => url.indexOf("://") > 0 || url.indexOf("//") === 0

    // function to generate proper link
    const generateLink = (url, target, text) => {

        const linkClass = "inline-block mt-14 px-8 py-3 border border-transparent text-base leading-6 font-semibold text-button-text bg-button-bg";

        // if relative link, use Gatsby Link
        if (isUrlAbsolute(url) === false) {
            return (
                <Link
                    to={url}
                    title={text}
                    target={target}
                    className={linkClass}
                >
                    {text}
                </Link>
            )
        } else {
            // else use anchor tag
            return (
                <a
                    href={url}
                    title={text}
                    target={target}
                    className={linkClass}
                >
                    {text}
                </a>
            )
        }
    }

    const publications = data.publications?.nodes?.filter((item) => {
        return item.customFields.publicationTypeID === module.customFields.publicationTypeID
    }) ?? []

    const rows = publications.map((item) => {
        return {
            primaryButton: item.customFields.primaryButton,
            image: item.customFields.image,
            publicationTitle: item.customFields.publicationTitle,
            description: item.customFields.briefDescription,
            descriptionTruncated: item.customFields.descriptionTruncated,
            descriptionDisplayed: item.customFields.descriptionTruncated,
            isExpanded: false,
            displayToggle: item.customFields.descriptionTruncated?.length !== item.customFields.briefDescription?.length
        }
    })

    const clickHandler = (rowIndex) => {
        let newRows = publicationRows;

        if (newRows[rowIndex].isExpanded) {
            newRows[rowIndex].descriptionDisplayed = newRows[rowIndex].descriptionTruncated;
            newRows[rowIndex].isExpanded = false;
        }
        else {
            newRows[rowIndex].descriptionDisplayed = newRows[rowIndex].description;
            newRows[rowIndex].isExpanded = true;
        }

        SetPublicationRows([...newRows]);
    }

    const [publicationRows, SetPublicationRows] = useState([...rows])

    return (
        <>
            {publicationRows.map((item, index) => {
                let textContainerClass = "lg:order-first lg:pr-16"
                let imageContainerClass = "lg:pl-16"
                let rowBgClass = ""
                if (index % 2 !== 0) {
                    textContainerClass = "lg:order-last lg:pl-16"
                    imageContainerClass = "lg:pr-16"
                    rowBgClass = "bg-gray-100"
                }
                return (
                    <div className={`publication-row relative px-8 lg:py-14 ${rowBgClass}`} key={index}>
                        <div className="flex flex-col lg:flex-row justify-between w-full max-w-screen-lg mx-auto py-12 items-start">
                            <div className={`publication-img-col w-full lg:w-6/12 flex flex-col items-center ${imageContainerClass}`}>
                                <span className="publication-subtitle block lg:hidden font-bold text-action text-lg text-left uppercase my-5 lg:mt-0 self-start">
                                    {item.publicationTitle}
                                </span>
                                {item.primaryButton ? (
                                    <Link to={item.primaryButton.href} className="flex w-full border border-body-text">
                                        <AgilityImage
                                            image={item.image}
                                            layout="fullWidth"
                                            className="w-full cursor-pointer"
                                        />
                                    </Link>
                                ) : (
                                    <AgilityImage
                                        image={item.image}
                                        layout="fullWidth"
                                        className="w-full cursor-pointer"
                                    />
                                )}
                            </div>
                            <div
                                className={`publication-text-col w-full lg:w-6/12 ${textContainerClass}`}
                            >
                                <div className="text-center md:text-left">
                                    <span className="publication-subtitle hidden lg:block font-bold text-action text-lg text-left uppercase my-5 lg:mt-0">
                                        {item.publicationTitle}
                                    </span>
                                    <h2 className="text-body text-4xl font-bold my-9 lg:mt-0">
                                        {item.publicationTitle}
                                    </h2>
                                    {item.description && <div dangerouslySetInnerHTML={{ __html: item.descriptionDisplayed }}
                                        className="text-body text-sm leading-6 pt-10 border-t border-t-gray-300">
                                    </div>}
                                    {item.displayToggle &&
                                        <a
                                            className="uppercade font-bold text-body-text text-sm leading-6 flex items-center gap-2 cursor-pointer mt-5"
                                            onClick={() => clickHandler(index)}
                                        >
                                            {`READ ${item.isExpanded ? "LESS" : "MORE"}`}
                                            {item.isExpanded && <FiChevronUp />}
                                            {!item.isExpanded && <FiChevronDown />}
                                        </a>
                                    }
                                    {item.primaryButton &&
                                        generateLink(
                                            item.primaryButton.href,
                                            item.primaryButton.target,
                                            item.primaryButton.text
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>)
            })}
        </>
    )

}

export default PublicationsListing